/* eslint-disable */
require([], function () {

  'use strict';

  // RequireJS config
  if ( typeof requirejs === 'function' ) {
    var config = {
      'waitSeconds': 30,
      'paths': { // vendor library paths here
        'jquery': 'vendor/jquery.min',
        'velocity': 'vendor/velocity'
      }
    };

    requirejs.config(config);
  }

  require(
    [
      'jquery',
      'modules/utils',
      'modules/config',
      'modules/tracking',
      'modules/menu',
      'modules/mute',
      'modules/camera',
      'modules/navigation',
      'modules/localisation',
      'modules/text-pre-processor',
      'modules/controller',
      'modules/asset-loader',
      'modules/spin-loader',
      'modules/animation',
      'modules/tile-nav',
      'modules/feature-view'
    ], 
    function (
      $,
      M_Utils,
      M_Config,
      M_Tracking,
      M_Menu,
      M_Mute,
      M_Camera,
      M_Navigation,
      M_Localisation,
      M_TextPreProcessor,
      M_Controller,
      M_AssetLoader,
      M_SpinLoader,
      M_Animation,
      M_TileNav,
      M_FeatureView
    ) {

    var pageNames = {
      intro: 'intro',
      reveal: 'reveal',
      experience: 'experience'
    };
    var carViews = {
      exterior: 'exterior',
      interior: 'interior'
    };
    var subViews = {
      features: 'features',
      spinA: 'spinA',
      spinB: 'spinB'
    };
    var easings = {
      linear: 'linear',
      smooth: [0.75, 0, 0.25, 1],
      decelerate: [0, 0, 0.25, 1]
    };

    M_Tracking.trackPageLoad();

    // Load config before initialising
    M_Config.init(function (err, config) {
      if ( err ) {
        console.log(err);
        return;
      }

      config.pageNames = pageNames;
      config.selectedPageName = pageNames.intro;
      config.carViews = carViews;
      config.selectedView = carViews.exterior;
      config.subViews = subViews;
      config.selectedSubView = subViews.features;
      config.easings = easings;

      return init(config);
    });

    function init (config) {
      M_Utils.init(config);
      M_AssetLoader.init(config);
      M_Localisation.init(config);
      M_TextPreProcessor.init();
      M_Menu.init(config);
      M_Mute.init(config);
      M_Camera.init(config);
      M_Navigation.init(config);
      M_Animation.init(config);
      M_Controller.init(config);
      M_SpinLoader.init(config);
      M_TileNav.init(config);
      M_FeatureView.init(config);

      M_Utils.triggerEvent('nx-experience-initialised');
    }
  });
});

define("main", function(){});

